import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Camera } from 'lucide-react';

export function CaptureFAB({ projectId, company }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user?.capture_enabled) return null;

  const handleClick = () => {
    const params = new URLSearchParams();
    if (projectId) params.set('project_id', projectId);
    else {
      params.set('type', 'project');
      if (company) params.set('company', company);
    }
    navigate(`/capture?${params.toString()}`);
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#F5A623] text-[#1E2530] shadow-lg shadow-[#F5A623]/20 flex items-center justify-center hover:bg-[#D98E1D] active:scale-90 transition-all"
      title="Capture receipt"
      data-testid="capture-fab"
    >
      <Camera className="w-6 h-6" />
    </button>
  );
}
